import '@/semantic/dist/semantic.min.css'
import Routes from './Routes'
import { useEventListener } from '@/hooks'

const App = () => {
  useEventListener('storage', event => {
    if (event.key === 'LOGGING_OUT' && event.newValue === 'true') {
      sessionStorage.removeItem('accessToken')
      sessionStorage.removeItem('refreshToken')
      sessionStorage.removeItem('userScope')
      window.location.reload()
    }

    if (event.key === 'SWITCHING_USER' && event.newValue === 'true') {
      window.location.reload()
    }
  })

  return <Routes />
}

export default App
